var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-share"},[_c('img',{attrs:{"src":"https://image.xiaomaiketang.com/xm/2mKEcDhcQy.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v("由小麦助教提供技术支持")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-410d00c7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/module/mall/MallShare.vue
// module id = 1534
// module chunks = 191